import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { AuthProvider } from '@react-components/auth';
// Login UI lives in sso2 (the centralized SSO portal that other apps redirect
// to); the auth logic/flows come from @react-components/auth via useAuth().
import { AuthPage, MagicLinkLandingPage, OtpPage } from './auth';
import { brand } from './auth/brand';
import appProps from '../appProps.json';
// ESP dark "frosted slate" theme — matches the sign-in screen design.
var espTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: brand.primary,
            contrastText: brand.onPrimary
        },
        background: {
            default: brand.bg,
            paper: brand.card
        },
        text: {
            primary: brand.textPrimary,
            secondary: brand.textSecondary
        },
        divider: brand.divider
    },
    shape: { borderRadius: 10 },
    typography: { fontFamily: brand.sans },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: { backgroundImage: 'none' }
            }
        }
    }
});
var basePath = appProps.hostedRootPath; // 'sso2'
var container = document.getElementById('app');
if (container) {
    var root = createRoot(container);
    root.render(_jsx(BrowserRouter, { children: _jsxs(ThemeProvider, { theme: espTheme, children: [_jsx(CssBaseline, {}), _jsx(AuthProvider, { app: { auth: appProps.auth }, children: _jsxs(Routes, { children: [_jsx(Route, { path: "/".concat(basePath, "/:companyKey"), element: _jsx(AuthPage, { basePath: basePath }) }), _jsx(Route, { path: "/".concat(basePath, "/login/:companyKey"), element: _jsx(AuthPage, { basePath: basePath }) }), _jsx(Route, { path: "/".concat(basePath, "/login/:companyKey/:appId"), element: _jsx(AuthPage, { basePath: basePath }) }), _jsx(Route, { path: "/".concat(basePath, "/otp/:companyKey"), element: _jsx(OtpPage, { basePath: basePath }) }), _jsx(Route, { path: "/".concat(basePath, "/otp/magic/:companyKey/:emailAddress/:magicToken"), element: _jsx(MagicLinkLandingPage, { basePath: basePath }) }), _jsx(Route, { path: "*", element: _jsx(AuthPage, { basePath: basePath }) })] }) })] }) }));
}
